import { CoinMarketData } from './coingecko';

export interface Token {
  id: string;
  name: string;
  symbol: string;
  marketData?: CoinMarketData;
  score: number;
}

export interface TokenStats {
  id: string;
  token: Token;
  totalBetsPlaced: bigint;
  totalBetsAmount: bigint;
  startFdv: bigint;
  startPrice: bigint;
  startVolatility: bigint;
  endFdv: bigint;
  endPrice: bigint;
  endVolatility: bigint;
}

export interface Bet {
  id: string;
  bettor: {
    id: string;
  };
  token: {
    id: string;
  };
  amount: bigint;
  timestamp: bigint;
}

export interface Race {
  id: string;
  name: string;
  status: RaceStatus;
  creator: {
    id: string;
  };
  bettingStartTime: bigint;
  raceStartTime: bigint;
  raceEndTime: bigint;
  creatorFeePercent: bigint;
  platformFeePercent: bigint;
  handicapEnabled: boolean;
  totalPool: bigint;
  concluded: boolean;
  tokenStats: TokenStats[];
  winnerStats?: TokenStats;
  bets: Bet[];
  totalWinningsClaimed: bigint;
  totalParticipants: bigint;
  createdAt: bigint;
  oracleStartTimestamp: bigint;
  oracleEndTimestamp: bigint;
}

export interface UserRaces {
  id: string;
  createdRaces: Race[];
  bets: Race[];
}

export enum RaceStatus {
  BETTING = 'BETTING',
  IN_PROGRESS = 'IN_PROGRESS',
  CONCLUDED = 'CONCLUDED',
}
